import {lazy} from "react";

export const ReportDailyExecutionSingleVoyageLazy = lazy(() => import('./ReportDailyExecutionSingleVoyage'))
